import { subMonths } from "date-fns";
import { DownloadDoc } from "./DownloadDoc";

export const AllStatements = () => {
    const getStatements = () => {
        const months = [];

        for (let i = 1; i < 6; i++) {
            const month = subMonths(new Date(), i);
            months.push(month);
        }

        return months;
    };

    const allStatementMonths = getStatements();

    return (
        <div className="all-statement-container">
            {allStatementMonths.map((x, i) => {
                return (
                    <div key={`statement-${i}`} className="download-statement-container">
                        <DownloadDoc month={x} />
                    </div>
                );
            })}
        </div>
    );
};
